import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=50a50f6c&scoped=true&"
import script from "./ModuleCard.vue?vue&type=script&lang=js&"
export * from "./ModuleCard.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=50a50f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a50f6c",
  null
  
)

export default component.exports